// Added by Jonghyung Lee on 2020-11-02
// Copyright (c) Coreline Soft, All rights are reserved.
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
import RootStore from '../../index'

import { SystemConfig } from '@/helper/define/systemConfigDefine'
import {
  reqGetSystemLanguageConfig,
  reqCreateSystemLanguageConfig,
  reqDeleteSystemLanguageConfig,
} from '@/service/systemConfig.service'
import Logger from '@/helper/Logger'
import { makeAutoObservable } from 'mobx'

interface SystemConfigStoreInterface {}

export default class SystemConfigStore implements SystemConfigStoreInterface {
  private _isInitialized: boolean = false
  _systemConfigOption: SystemConfig = {}
  _root?: RootStore

  constructor(root: RootStore) {
    this._root = root
    makeAutoObservable(this)
  }

  get systemConfigsOption() {
    return this._systemConfigOption
  }

  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  // Private Methods

  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  // Public Methods
  public async initialize(force = false) {
    if (this._isInitialized && !force) {
      Logger.infoLog('SystemConfig is already initialized')
      return
    }

    const { data: languageConfigOption } = await reqGetSystemLanguageConfig()

    this._systemConfigOption = {
      languageConfig: languageConfigOption,
    }

    this._isInitialized = true
  }

  public createLanguageConfig = async (newLanguageConfig: FormData) => {
    try {
      const { status } = await reqCreateSystemLanguageConfig(newLanguageConfig)
      return status
    } catch (error) {
      return Number(error.response.status)
    } finally {
      const { data: languageConfigOption } = await reqGetSystemLanguageConfig()
      this._systemConfigOption = {
        languageConfig: languageConfigOption,
      }
    }
  }

  public deleteLanguageConfig = async (langCode: string) => {
    await reqDeleteSystemLanguageConfig(langCode)
    const { data: languageConfigOption } = await reqGetSystemLanguageConfig()
    this._systemConfigOption = {
      languageConfig: languageConfigOption,
    }
  }
}
